import objectAssignDeep from 'object-assign-deep'
import RenElement from './ren-element.es6'

const initialTextMeta = { text: 'Text', fontSize: '25', horizontalAlign: 'left' }
// Keep all values as strings to have the type consistent even after it gets updated in a form

export default class RenElementAdding extends RenElement {
  constructor (attrs, renAttrs, eventHandlers, elementType, assetId) {
    const element = {
      position: { points: [0, 0], rotation: 0, label: { rotation: 0 } },
      deviceTyp: elementType.deviceTyp,
      elementTypeName: elementType.name,
      pattern: elementType.pattern,
      assetId: assetId,
      meta: elementType.name === 'Text' ? initialTextMeta : undefined
    }

    super(
      // Konva properties
      Object.assign({
        x: 0,
        y: 0,
        id: 'adding'
      }, attrs),
      Object.assign({
        // Ren properties
        _element: element
      }, renAttrs),
      Object.assign({
        // Ren events
        handleClick: function () {
        },
        handleDragmove: function () {
        },
        handleUpdate: undefined
      }, eventHandlers)
    )

    // Notify the renStage
    this.renStage.addingElementMode = true

    // Bind non-own events (must be unbound on destroy)
    this.evtHandleKeyDown = this._onKeyDown.bind(this) // Must bind here so that the function signature is the same for removeEventListener
    window.addEventListener('keydown', this.evtHandleKeyDown, true)

    this.renStage.on('contentMousemove.addingElementByType', () => {
      const point = [this.renStage.stagePosition.x, this.renStage.stagePosition.y]
      this.setPoints(this.getUpdatedPoints(point, -1))
    })

    this.renStage.getRenElement('bottom', 'bottom').on('click.addingElementByType', () => {
      // Must be bound both to element and bottom click
      console.log('EVT[bottom.click.addingElementByType]')
      this._proceedAdding()
    })
    console.log(this.renStage.getRenElement('bottom', 'bottom'))
  }

  bindEvents () {
    this.on('click', () => {
      console.log('EVT[ren-element-adding]:click')
      // Must be bound both to element and bottom click
      this.onClick()
    })
  }

  destroy () {
    // Unbind non-own events
    window.removeEventListener('keydown', this.evtHandleKeyDown, true)
    this.renStage.off('contentMousemove.addingElementByType')
    this.renStage.getRenElement('bottom', 'bottom').off('click.addingElementByType')
    // Notify the renStage
    this.renStage.addingElementMode = false
    // Destroy
    super.destroy()
  }

  _proceedAdding () {
    // TODO: Not tested yet
    if (this._element.pattern === 'node') {
      // For nodes, end the process
      this._endAdding(true)
    } else {
      // For vectors/areas, add new point
      const point = [this.renStage.stagePosition.x, this.renStage.stagePosition.y]
      this.setPoints(this.getUpdatedPoints(point, undefined))
    }
  }

  _endAdding (saveLastPoint) {
    const layer = this.parent

    if (this._element.pattern === 'node') {
      // Node
      if (saveLastPoint) {
        // Save the element to DB
        this._savePersistently()
      }
    } else {
      // Vector/area
      if (!saveLastPoint) {
        // Trim the last point from the points
        this.setPoints(this.getSplicedPoints(-1, 1))
      }
      // Save the element to DB
      this._savePersistently()
    }

    this.destroy()
    layer.draw()
  }

  _savePersistently () {
    // Clone element to avoid mutation
    const newElement = objectAssignDeep({}, this._element)
    // Apply new rotation + Snap to 45deg.
    newElement.position.points = this.getPoints()
    if (newElement.pattern !== 'node' && newElement.position.points.length < 4) {
      return // skip saving 1-point vectors and arrays
    }
    // Handle
    this.handleUpdate(newElement)
  }

  // This must be a public method as it gets called also from renElement.click.main
  onClick () {
    this._proceedAdding()
  }

  _onKeyDown (evt) {
    console.log('_onKeyDown - this:')
    console.log(this)
    if (evt.key === 'Escape' || evt.key === 'Esc') {
      // End adding element by type (if in progress)
      console.log('ESC PRESSED')
      this._endAdding(false)
    } else if (evt.key === 'Enter') {
      console.log('ENTER PRESSED')
      // Proceed adding element by type (if in progress)
      this._proceedAdding()
    }
  }
}
